import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAlert } from '../Common/Alert';
import AlertModal from '../Common/Alert';
import { hideNativeTabBar, showNativeTabBar } from '../../services/api';
import './Login.css';

// 백엔드 OAuth 콜백은 Swagger 명세상 https://coin.mmstudio.co.kr:20444 에 위치한다.
const KAKAO_JS_KEY = 'c2605fba33207e998cc8656f55c7be44';
const KAKAO_REDIRECT_URI = 'https://coin.mmstudio.co.kr:20444/api/v1/open/auth/kakao/oauth';

const APPLE_AUTH_URL = 'https://appleid.apple.com/auth/authorize?client_id=MakeMoneyStudio.CoinCommandos.AppleID&redirect_uri=https%3A%2F%2Fcoin.mmstudio.co.kr%3A20444%2Fapi%2Fv1%2Fopen%2Fauth%2Fapple%2Foauth&response_type=code&scope=name%20email&response_mode=form_post';

const SLIDES = 4;

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { alert, showAlert, closeAlert } = useAlert();
  const [slide, setSlide] = useState(0);
  const [scoreVal, setScoreVal] = useState(0);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  useEffect(() => {
    document.title = '로그인 | 코인특공대';
    return () => { document.title = '코인특공대'; };
  }, []);

  useEffect(() => {
    hideNativeTabBar();
    // return () => showNativeTabBar();
  }, []);

  useEffect(() => {
    const successYn = searchParams.get('successYn');
    const error = searchParams.get('error');
    const reason = searchParams.get('reason');
    if (successYn === 'N' && error) {
      showAlert('error', error, { autoClose: false });
      setSlide(SLIDES - 1);
    } else if (reason === 'token_expired') {
      showAlert('error', '오랫동안 자리를 비우셨나요? 안전한 사용을 위해 다시 로그인해 주세요.', { autoClose: false });
      setSlide(SLIDES - 1);
    }
  }, []);

useEffect(() => {
    if (slide !== 1) return;
    setScoreVal(0);
    const tid = setTimeout(() => {
      let n = 0;
      const iv = setInterval(() => {
        n = Math.min(n + 3, 87);
        setScoreVal(n);
        if (n >= 87) clearInterval(iv);
      }, 18);
      return () => clearInterval(iv);
    }, 350);
    return () => clearTimeout(tid);
  }, [slide]);

  const goTo = (i) => {
    if (i < 0 || i >= SLIDES || i === slide) return;
    if (i === 1) setScoreVal(0);
    setSlide(i);
  };

  const cls = (i) => {
    if (i === slide) return 'ob-slide ob-slide--active';
    if (i < slide) return 'ob-slide ob-slide--left';
    return 'ob-slide ob-slide--right';
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = Math.abs(e.changedTouches[0].clientY - touchStartY.current);
    if (Math.abs(dx) > 50 && dy < 80) {
      if (dx < 0) goTo(slide + 1);
      else goTo(slide - 1);
    }
    touchStartX.current = null;
  };

  const handleKakaoLogin = () => {
    if (!window.Kakao) {
      window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=7797bf00713b5a91bf00b36871d82ca0&redirect_uri=${encodeURIComponent(KAKAO_REDIRECT_URI)}&response_type=code`;
      return;
    }
    if (!window.Kakao.isInitialized()) window.Kakao.init(KAKAO_JS_KEY);
    window.Kakao.Auth.authorize({ redirectUri: KAKAO_REDIRECT_URI, throughTalk: true });
  };

  const isLogin = slide === SLIDES - 1;
  const circumference = 2 * Math.PI * 80;

  return (
    <>
      <AlertModal alert={alert} onClose={closeAlert} />
      <div className="ob-screen" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
        <div className="ob-bg" />
        <div className="ob-grid" />
        <div className="ob-glow" />

        {/* Top bar */}
        <div className="ob-topbar">
          <button
            className="ob-skip-btn"
            onClick={() => goTo(SLIDES - 1)}
            style={{ visibility: isLogin ? 'hidden' : 'visible' }}
          >
            건너뛰기
          </button>
        </div>

        {/* Slides */}
        <div className="ob-slides">

          {/* Slide 0: Hero */}
          <div className={cls(0)}>
            <div className="ob-hero">
              <div className="ob-orb">
                <div className="ob-orb-r3" />
                <div className="ob-orb-r2" />
                <div className="ob-orb-r1" />
                <div className="ob-orb-core">
                  <img src="/logo.png" alt="코인특공대" />
                </div>
              </div>
              <div className="ob-hero-txt">
                <p className="ob-eyebrow">CRYPTO AI</p>
                <h1 className="ob-hero-h1">AI가 점수로<br />알려주는 코인 투자</h1>
                <p className="ob-hero-p">복잡한 크립토 시장, 이제 AI에게 맡기세요</p>
              </div>
            </div>
          </div>

          {/* Slide 1: AI Score */}
          <div className={cls(1)}>
            <div className="ob-feat">
              <div className="ob-score">
                <svg className="ob-score-svg" viewBox="0 0 200 200">
                  <defs>
                    <linearGradient id="scoreGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#3b82f6" />
                      <stop offset="100%" stopColor="#93c5fd" />
                    </linearGradient>
                  </defs>
                  <circle cx="100" cy="100" r="80" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="14" />
                  <circle
                    cx="100" cy="100" r="80"
                    fill="none"
                    stroke="url(#scoreGrad)"
                    strokeWidth="14"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={circumference * (1 - scoreVal / 100)}
                    transform="rotate(-90 100 100)"
                  />
                </svg>
                <div className="ob-score-num">
                  <span className="ob-score-v">{scoreVal}</span>
                  <span className="ob-score-u">점</span>
                </div>
              </div>
              <div className="ob-feat-txt">
                <span className="ob-tag">AI 코인 점수</span>
                <h2 className="ob-feat-h2">매일 새벽,<br />코인별 AI 분석</h2>
                <p className="ob-feat-p">-100~100점으로 모든 코인을 분석하여<br />트레이딩 판단을 쉽게 도와드립니다</p>
              </div>
            </div>
          </div>

          {/* Slide 2: Market */}
          <div className={cls(2)}>
            <div className="ob-feat">
              <div className="ob-bars">
                {[58, 40, 82, 52, 90, 30, 68].map((h, i) => (
                  <div key={i} className="ob-bar-col">
                    <div
                      className="ob-bar"
                      style={{
                        '--bh': `${h}%`,
                        '--bd': `${i * 75}ms`,
                        background: h > 70
                          ? '#F5C518'
                          : h > 48
                          ? 'rgba(245,197,24,0.45)' : h > 30  ? 'rgba(245,197,24,0.24)'
                          : 'rgba(245,197,24,0.14)',
                      }}
                    />
                  </div>
                ))}
              </div>
              <div className="ob-feat-txt">
                <span className="ob-tag">크립토 시장 분석</span>
                <h2 className="ob-feat-h2">공포탐욕지수부터<br />온체인 지표까지</h2>
                <p className="ob-feat-p">펀딩레이트, NVT, 활성 주소 등<br />핵심 크립토 지표를 한눈에 확인하세요</p>
              </div>
            </div>
          </div>

          {/* Slide 3: Login header */}
          <div className={cls(3)}>
            <div className="ob-login-head">
              <div className="ob-login-icon">
                <img src="/logo.png" alt="코인특공대" />
              </div>
              <h2 className="ob-login-h2">코인특공대</h2>
              <p className="ob-login-p">소셜 계정으로 간편하게 로그인하세요</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="ob-bottom">
          <div className="ob-dots">
            {Array.from({ length: SLIDES }).map((_, i) => (
              <button
                key={i}
                className={`ob-dot${i === slide ? ' ob-dot-on' : ''}`}
                onClick={() => goTo(i)}
              />
            ))}
          </div>

          {isLogin ? (
            <div className="ob-btns">
              <button className="ob-btn-kakao" onClick={handleKakaoLogin}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 3C6.477 3 2 6.477 2 10.818c0 2.74 1.522 5.153 3.836 6.661l-.98 3.639a.3.3 0 0 0 .443.336L9.8 19.1A11.26 11.26 0 0 0 12 19.636c5.523 0 10-3.477 10-7.818C22 6.477 17.523 3 12 3Z" fill="currentColor" />
                </svg>
                <span>카카오로 시작하기</span>
              </button>

              <button className="ob-btn-apple" onClick={() => { window.location.href = APPLE_AUTH_URL; }}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.4c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4ZM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25Z" fill="currentColor" />
                </svg>
                <span>Apple로 시작하기</span>
              </button>

              <button className="ob-btn-guest" onClick={() => {
                if (window.webkit?.messageHandlers?.getIsTappedBrowseButton) {
                  window.webkit.messageHandlers.getIsTappedBrowseButton.postMessage(null);
                } else if (window.getIsTappedBrowseButton) {
                  window.getIsTappedBrowseButton.postMessage('');
                }
                showNativeTabBar();
                navigate('/coinMain');
              }}>
                둘러보기
              </button>
            </div>
          ) : (
            <button className="ob-btn-next" onClick={() => goTo(slide + 1)}>
              다음
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Login;
